import * as React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/index.css'
import App from './Chatbot/app'



const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

